<template>
	<div class="xpage-breadcrumbs">
		<router-link to="/" class="icon-home"></router-link>
		<span>></span>
		<router-link :to="`/${props.pageName.toLowerCase()}`">{{
			props.pageName
		}}</router-link>
	</div>
</template>

<script setup lang="ts">
import { defineProps } from "vue";

const props = defineProps({
	pageName: {
		type: String,
		default: "",
	},
});
</script>